import { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
export function useFetch(url, token = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { logout } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        });

        const jsonResult = await res.json();
        
        if (!res.ok) {
          if (
            jsonResult?.error === 'Unauthorized' &&
            jsonResult?.message === 'Invalid token'
          ) {
            logout();
          }
          throw new Error('Network response was not ok');
        }

        //const json = await res.json();
        setData(jsonResult);
      } catch (err) {
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, token]);

  return { data, loading, error };
}
